import Axios from "axios";
import {GET_BLOG_POSTS, saveBlogPosts} from "../actions/posts";
import {getApiBaseUrl} from "../utils/baseUrl";
import {setErrorApiMessage} from "../actions/apiFlag";

Axios.defaults.timeout = 1000000;

const posts = (store) => (next) => (action) => {
    switch (action.type) {
        case GET_BLOG_POSTS : {
            const url = `${getApiBaseUrl()}/getBlog/`;
            Axios.post(url)
                .then((res) => {
                    store.dispatch(saveBlogPosts(res.data.listBlog));
                    console.log("STORE", store.getState());
                })
                .catch((err) => {
                    if (err) {
                        if (err.code === "ECONNABORTED") {
                            store.dispatch(setErrorApiMessage(true));
                        }
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
        }
            next(action);
            break;
        default:
            next(action);
    }
};

export default posts;